DJ.addBehavior('recette-summary', '.recette-middle__summary', {
  attach: function (context, settings, behavior) {
    const summaryContainer = document.querySelector(".recette-middle__summary");
    const childContainers = document.querySelectorAll("#ingredients, #preparation, #zoom");

    if (!childContainers) {
      return;
    }

    const summaryTitle = document.querySelector(".recette-middle__summary-title");
    const summaryList = document.querySelector(".recette-middle__summary-items");

    summaryContainer.onclick = function () {
      summaryList.classList.toggle("active");
      summaryTitle.classList.toggle("active");
    };

    const header = document.querySelector(".header");
    const mutationCallback = (mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          if (header.classList.contains("hide")) {
            summaryContainer.style.top = "0px";
          } else {
            summaryContainer.style.top = header.clientHeight + "px";
          }
        }
      });
    };

    const mutationObserverConfig = { attributes: true };
    const mutationObserver = new MutationObserver(mutationCallback);

    mutationObserver.observe(header, mutationObserverConfig);

    const tocLinks = document.querySelectorAll(".recette-middle__summary-item");

    // on window scroll
    let prevScrollPos = window.scrollY;
    window.addEventListener("scroll", () => {
      let active = null;
      const currentScrollPos = window.scrollY;

      childContainers.forEach((container) => {
        const vh = window.innerHeight;
        const vc = vh / 2;

        if (container.getBoundingClientRect().top <= vc && container.getBoundingClientRect().bottom >= vc) {
          active = container.id;
        }
      });

      if (!active) return;

      if (document.querySelector(".recette-middle__summary-item.active"))
        document.querySelector(".recette-middle__summary-item.active").classList.remove("active");

      document.querySelector("[href='#" + active + "']").parentElement.classList.add("active");


      prevScrollPos = currentScrollPos;
    });

    tocLinks.forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        const target = document.getElementById(
          item.querySelector("a").getAttribute("href").substring(1)
        );

        if (target) {
          const currentScrollPosition = window.pageYOffset;
          const targetPosition =
            target.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition =
            targetPosition < currentScrollPosition
              ? targetPosition -
              header.clientHeight - (window.matchMedia("(max-width: 975px)").matches ? summaryContainer.clientHeight : 0) - 20
              : targetPosition - (window.matchMedia("(max-width: 975px)").matches ? summaryContainer.clientHeight : 0) - 20;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      });
    });

  },

  detach: function (context, settings) { }
});
